import { render } from "./InputRadioGroup.vue?vue&type=template&id=09ceb79e&scoped=true"
import script from "./InputRadioGroup.vue?vue&type=script&lang=js"
export * from "./InputRadioGroup.vue?vue&type=script&lang=js"

import "./InputRadioGroup.vue?vue&type=style&index=0&id=09ceb79e&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ceb79e"]])

export default __exports__